/* Käufer Hell/Dunkel-Umschalter (Modus dark_mode == 'choice').
   Togglet die Klasse `dark-mode` (+ optional `dark-mode--floating-header`) auf
   <html>, persistiert die Wahl in localStorage('theme-mode') und folgt der
   System-Einstellung, solange noch keine aktive Wahl getroffen wurde.
   Die initiale Klasse setzt bereits das No-FOUC-Inline-Script im <head>
   (layout/theme.liquid); dieses Script hängt nur das interaktive Verhalten an. */
(function () {
  if (window.customElements && customElements.get('theme-toggle')) return;

  var DARK_META = '#0c0e13';

  function storedMode() {
    try { return localStorage.getItem('theme-mode'); } catch (e) { return null; }
  }

  class ThemeToggle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.floating = this.hasAttribute('data-floating-header');
      this.media = window.matchMedia('(prefers-color-scheme: dark)');

      // aria-pressed an den tatsächlichen Zustand angleichen (No-FOUC-Script
      // kann die Klasse schon vor JS gesetzt haben).
      this.button.setAttribute('aria-pressed', String(this._isDark()));

      this._onClick = this._toggle.bind(this);
      this.button.addEventListener('click', this._onClick);

      // Systemwechsel nur folgen, solange keine explizite Wahl gespeichert ist.
      this._onMedia = function (e) {
        if (storedMode() === null) this._apply(e.matches, false);
      }.bind(this);
      if (this.media.addEventListener) {
        this.media.addEventListener('change', this._onMedia);
      } else if (this.media.addListener) {
        this.media.addListener(this._onMedia);
      }
    }

    disconnectedCallback() {
      if (this.button && this._onClick) this.button.removeEventListener('click', this._onClick);
      if (this.media && this._onMedia) {
        if (this.media.removeEventListener) this.media.removeEventListener('change', this._onMedia);
        else if (this.media.removeListener) this.media.removeListener(this._onMedia);
      }
    }

    _isDark() {
      return document.documentElement.classList.contains('dark-mode');
    }

    _toggle() {
      this._apply(!this._isDark(), true);
    }

    _apply(dark, persist) {
      var el = document.documentElement;
      el.classList.toggle('dark-mode', dark);
      if (this.floating) el.classList.toggle('dark-mode--floating-header', dark);
      this.button.setAttribute('aria-pressed', String(dark));
      this._setMeta(dark);
      if (persist) {
        try { localStorage.setItem('theme-mode', dark ? 'dark' : 'light'); } catch (e) {}
      }
    }

    _setMeta(dark) {
      var m = document.querySelector('meta[name="theme-color"]');
      if (dark) {
        if (!m) {
          m = document.createElement('meta');
          m.setAttribute('name', 'theme-color');
          document.head.appendChild(m);
        }
        m.setAttribute('content', DARK_META);
      } else if (m) {
        m.parentNode.removeChild(m);
      }
    }
  }

  customElements.define('theme-toggle', ThemeToggle);
})();
